<div class="flex flex-col items-center justify-center">
    <button nz-button nzType="primary" class="w-1/2 h-8 my-5" (click)="registerUserSupport('login')">
        Iniciar sesión
    </button>
    <button nz-button nzType="primary" class="w-1/2 h-8 mb-5" (click)="registerUserSupport('register')">
        Acceso de apoyo
    </button>
</div>
